import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
  type UseMutationResult,
} from '@tanstack/react-query';
import service from '../service';
import { assetTagKeys } from './useAssetTags';

export interface DeleteAssetTagVariables {
  id: string;
}

export function useDeleteAssetTag(
  options?: UseMutationOptions<void, Error, DeleteAssetTagVariables>,
): UseMutationResult<void, Error, DeleteAssetTagVariables> {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation<void, Error, DeleteAssetTagVariables>({
    mutationKey: ['assetTag', 'delete'],
    mutationFn: async ({ id }) => {
      return service.deleteAssetTag(id);
    },
    retry: (failureCount, error: any) => {
      const status =
        error?.status ??
        error?.response?.status ??
        error?.cause?.status ??
        null;
      const isServerOrNetwork = status == null || status >= 500;
      return failureCount < 2 && isServerOrNetwork;
    },
    ...restOptions,
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({ queryKey: assetTagKeys.all });
      onSuccess?.(data, variables, onMutateResult, context);
    },
  });
}
